import MainLayout from "./layout/MainLayout/index";
import LoginLayout from "./layout/LoginLayout";
import GlobalContext from "./contexts/globalcontext";
import { useContext, useEffect } from "react";
import useRefreshToken from "./hooks/useRefreshToken";

function App() {
    const { auth } = useContext(GlobalContext);
    const refreshToken = useRefreshToken();
    // console.log("auth", auth);
    useEffect(() => {
        if (!auth?.username) {
            // console.log("No user in memory, try refresh");
            refreshToken();
        }
    }, []);

    return <>{auth.username ? <MainLayout /> : <LoginLayout />}</>;
}

export default App;
